<template>
    <div class="card">
        <TabView>
            <TabPanel header="ข้อมูลประเภทร้านค้า">
                <system-general></system-general>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import systemGeneral from './InformationGeneral';

export default {
    components: {
        systemGeneral
    },
    data() {
      return{
      }    
    },
    created(){
    },

    mounted(){

    },

    watch:{
       
    },
    computed: {

    }
}
</script>